import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { Http, Headers } from '@angular/http';
import { Router } from '@angular/router';
import { AppSettings } from '../constants/constants';
import { ConfirmationDialogService } from 'src/app/components/confirmation-dialog/confirmation-dialog.service';

@Injectable({
  providedIn: 'root'
})
export class LoginDataService {

  public islogin: boolean = false;

  serviceloginChange: Subject<boolean> = new Subject<boolean>();

  userBO: any = {};
  userrolerightsColl: any = [];
  outletColl: any = [];
  companysettingsColl: any = [];
  userView: any = {};

  companyid: number = 0;

  isshowmenu: boolean = false;

  isnavmobile: boolean = false;
  isnavfix: boolean = false;

  isaccounts: boolean = false;

  constructor(private http: Http, public router: Router, private confirmationDialogService: ConfirmationDialogService) { }


  fnpostInputParams(url, params) {

    const headers = new Headers({

      //'Content-Type': "application/JSON",
      'token': (localStorage.bstoken === undefined) ? '' : JSON.parse(localStorage.bstoken),

    });

    return this.http.post(AppSettings.base_url + url, params, { headers: headers });
  }

  //Get UserRole List
  fnGetUserRoleList() {
    var data = {
      'userid': 0,
    }

    this.fnpostInputParams(AppSettings.getUserRoleRightsUserUrl, data)
      .subscribe(
        (res) => {

          if (res.json().status == 200) {
            var _res = res.json().result;

            if (_res.length) {


              if (_res[0].length > 0) {
                this.userBO = _res[0][0];


                this.companyid = this.userBO.companyid;

                this.isaccounts= this.userBO.isaccounts;
              }
              else {
                this.userBO = {};
              }

              this.userrolerightsColl = [];

              this.userrolerightsColl = _res[1];

              this.outletColl = _res[2];

              this.companysettingsColl = _res[3];
            }


            this.userView = {
              userBO: this.userBO,
              userrolerightsColl: this.userrolerightsColl,
              outletColl: this.outletColl
            }

            this.fnSetCurrencyFormat()

            this.serviceloginChange.next(this.userView);
          }
          else if (res.json().status == 400) {
            this.fnShowErrorMsg('Error' + res.json().err_field);
          }
        },
        (err) => {

          this.fnShowErrorMsg('Error' + err);
        })

  }


  fnSetCurrencyFormat() {
    if (this.userBO.currencyname === "OMR") {
      localStorage.setItem('currency', "OMR");
    }
    else {
      if (localStorage.currency !== undefined) {
        localStorage.setItem('currency', "INR");
      }

    }

  }


  fnCheckUser() {
    if (this.userBO.userid) {
      return true;
    }
    else if (localStorage.bstoken !== undefined) {
      return false;
    }
    else {
      return false;
    }

  }

  fnCheckOrganizationUser() {

    if (this.userBO.isorganizationaccess) {
      return true;
    }
    else {
      return false;
    }

  }

  fnGetModUserId() {
    if (this.userBO.userid) {
      return this.userBO.userid;
    }
    else {
      return 0;
    }
  }
  fnCheckCompany() {

    // if (this.companyid == 0) {
    //   return false;
    // }
    // else    
    if (this.fnCheckOrganizationUser()) {
      return true;
    }
    else if (this.companyid > 0) {
      return true;
    }
    else if (this.fnGetCompanyId() == 0) {
      return false;
    }

  }

  fnGetCompanyId() {
    if (this.fnCheckOrganizationUser()) {
      if (localStorage.getItem('bscmp')) {
        if (localStorage.getItem('bscmp') !== '') {
          return Number(localStorage.getItem('bscmp'));
        }
        else {
          return 0;
        }
      }
      else {
        return 0;
      }
    } else {
      return this.companyid;
    }

    // return this.companyid;
  }


  fnGetOrganizationId() {
    if (this.userBO.organizationid) {
      return this.userBO.organizationid;
    }
    else {
      return 0;
    }
  }



  fnCompanyFaildRedirect() {

  }



  fnUserFaildRedirect() {
    if (!this.userBO) {
      this.router.navigate(['/Login']);
    }
  }

  fnCheckAdminUser() {

    if (this.userBO.userid) {
      return this.userBO.isadmin;
    }
    else {
      return 0;
    }
  }



  public fnDatePickerClose(event, datepicker) {
    if (event.relatedTarget) {
      if (event.relatedTarget.parentNode.nodeName !== 'BS-DATEPICKER-NAVIGATION-VIEW') {
        datepicker.hide();
      }
    }
  }

  fnCheckUserRoleAll(formname) {


    if (this.userrolerightsColl) {

      const index = this.userrolerightsColl.findIndex(abo => abo.userappformname === formname);
      if (index > -1) {
        var _pBO = this.userrolerightsColl[index];

        if (_pBO.uappcreate || _pBO.uappalter || _pBO.uappdelete || _pBO.uappview || _pBO.uappprint || _pBO.uappexport) {
          return true;
        }
        else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  fnCheckUserRoleAction(formname, action) {



    if (this.userrolerightsColl) {

      const index = this.userrolerightsColl.findIndex(abo => abo.userappformname === formname);
      if (index > -1) {
        var _pBO = this.userrolerightsColl[index];

        if (action === 'CREATE' && _pBO.uappcreate) {
          return true;
        }
        else if (action === 'ALTER' && _pBO.uappalter) {
          return true;
        }
        else if (action === 'DELETE' && _pBO.uappdelete) {
          return true;
        }
        else if (action === 'VIEW' && _pBO.uappview) {
          return true;
        }
        else if (action === 'PRINT' && _pBO.uappprint) {
          return true;
        }
        else if (action === 'EXPORT' && _pBO.uappexport) {
          return true;
        }
        else {
          return false;
        }
      }
      else {
        return false;
      }

    } else {
      return false;
    }
  }


  fnCheckCompanysettings(formname) {

    if (this.companysettingsColl) {
      const index = this.companysettingsColl.findIndex(abo => abo.settingsname === formname);
      if (index > -1) {
        var _pBO = this.companysettingsColl[index];

        return _pBO.settingsvalue;
      } else {
        return '';
      }
    } else {
      return '';
    }
  }


  fnDecimalBlur(event) {
    if (event.target.value !== '') {

      event.target.value = parseFloat(event.target.value).toFixed((localStorage.currency !== undefined && localStorage.currency === 'OMR') ? 3 : 2)

    }
  }

 public fngetDecimalPlaces() {
    if ((localStorage.currency !== undefined && localStorage.currency === 'OMR')) {
      return 'separator.3'
    }
    else if (this.userBO.currencyname === "OMR") {
      return 'separator.3'
    }
    else{
      return 'separator.2'
    }

  }

  fnCheckLogin() {
    if (localStorage.bstoken === undefined) {
      this.router.navigate(['/Login']);
    }

  }

  fnShowMenu() {

    this.isshowmenu = !this.isshowmenu;
  }

  private fnShowErrorMsg(ex) {

  }


  public print(printEl: HTMLElement) {
    let printContainer: HTMLElement = document.querySelector('#print-container');

    if (!printContainer) {
      printContainer = document.createElement('div');
      printContainer.id = 'print-container';
    }

    printContainer.innerHTML = '';

    let elementCopy = printEl.cloneNode(true);
    printContainer.appendChild(elementCopy);
    document.body.appendChild(printContainer);

    window.print();
  }

  fnSetFirstControlFocus(id) {

    try {
      setTimeout(() => {
        document.getElementById(id).focus
      }, 400);
    }
    catch {

    }
  }
  fnCheckZeroDetcimal(value) {

    if (value === '' || value === null) {
      return 0
    }
    else {
      return Number(value)
    }
  }


  public fnDatePickerOpen(datepicker) {
    if (datepicker) {

      datepicker.toggle();

    }
  }




  fnConfirmFormLeave(): Promise<boolean> {

    return this.confirmationDialogService.confirm('Confirm..', 'Do you  want to leave this page?')
      .then((confirmed) => {
        if (confirmed) {
          return true;
        }
        else {
          return false
        }

      }
      );


  }

}
